<template>
  <div class="card text-gray-800" v-if="result">
    <div class="card-header">
      <div class="flex justify-between">
        <div>
          <h2 class="card-heading text-gray-700">Statistics</h2>
        </div>
        <div class="card-subheading">
          <span class="ml-1 text-gray-700">Current Month</span>
        </div>
      </div>
    </div>
    <div class="card-content ">
      <div class="flex flex-wrap">
        <div class="w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
          <div class="flex">
            <div class="pt-2">
              <i class="fal text-gray-700 text-2xl fa-container-storage"></i>
            </div>
            <div class="pl-2">
              <p class="text-lg font-semibold mb-0 text-gray-700">
                {{ result.containers_handled.Throughput }}
                <span class="ml- text-gray-700 text-xs">TEUS</span>
              </p>
              <p class="ttext-gray-700 text-xs">Loading / Unloading</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
          <div class="flex">
            <div class="pt-2">
              <i class="fal text-gray-700 text-2xl fa-cloud-meatball"></i>
            </div>
            <div class="pl-2">
              <p class="text-lg font-semibold mb-0 text-gray-700">
                {{ Math.round(result.freights.Freight_Ton) }}
                <span class="ml- text-gray-700 text-xs">Tons</span>
              </p>
              <p class="text-gray-700 text-xs">General Cargos</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
          <div class="flex">
            <div class="pt-2">
              <i class="fal text-gray-700 text-2xl fa-truck-container"></i>
            </div>
            <div class="pl-2">
              <p class="text-lg font-semibold mb-0 text-gray-700">
                {{
                  result.shifting_requests.Express_Requests +
                  result.shifting_requests.Normal_Requests
                }}
                <span class="ml- ttext-white text-xs">Units</span>
              </p>
              <p class="text-gray-700 text-xs">Shifting Requests</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
          <div class="flex">
            <div class="pt-2">
              <i class="fal text-gray-700 text-2xl fa-ship"></i>
            </div>
            <div class="pl-2">
              <p class="text-lg font-semibold mb-0 text-gray-700">
                {{ result.ships.Ships_Handled }}
                <span class="ml- text-gray-700 text-xs">Vessels</span>
              </p>
              <p class="text-gray-700 text-xs">Ships Handled</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({
})
export default class OverallStatistics extends Vue {
  private service = new BandharuService();

  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  private loading = false;

  private result = null;
  private clearingagents = null;
  private current = "shipagent";

  private form = {
    container: "",
  };

  resetResults() {
    this.result = null;
  }

  mounted() {
    this.getOverallStatistics();
  }

  getOverallStatistics() {
    this.loading = true;
    this.service
      .getOverallStatistics()
      .then((res) => {
        this.result = res;
        this.loading = false;
      })
      .catch((error) => {
        console.log("Error");
        this.loading = false;
      });
  }
}
</script>
